import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { STORAGE } from "src/app/constant/storages";
import { _getStorage } from "src/app/utils/local-storage";

@Component({
  selector: "app-backoffice",
  templateUrl: "./backoffice.component.html",
  styleUrls: ["./backoffice.component.scss"],
})
export class BackofficeComponent implements OnInit {


  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";

  constructor(public router: Router) {}

  ngOnInit() {}

  ionViewDidEnter() {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    if (
      this.userRole !== "ETAXSUPERADMIN" &&
      this.userRole !== "SUPERADMIN"
    ) {
      this.router.navigate(["home"]);
    } else {
      this.router.navigate(["backoffice/external-report"]);
    }
  }
}
